// core
import {NgModule, Optional, SkipSelf} from '@angular/core';

// services
import {ErrorMessageService} from './alert-message/alert-message.service';
import {TranslateService} from '@ngx-translate/core';
import {UserRegistrationServiceService} from '../user-registration/service/user-registration-service.service';
import {EmailConfirmationService} from '../email-confirmation/service/email-confirmation.service';

/**
 * @description Modularity system which helps organize the app into cohesive blocks of functionality
 * @example https://angular.io/guide/architecture#modules
 * @tutorial https://angular.io/guide/ngmodule
 */
@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: [
        UserRegistrationServiceService,
        EmailConfirmationService,
        ErrorMessageService,
        TranslateService
    ]
})
export class CoreModule {

  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
